import React, { useState, useEffect } from 'react'
import CustomDialog from '../../sharedcomponents/dialog/dialog';
import
{
    TextField, InputAdornment, Box, ListItem, Card, CardContent, CircularProgress
} from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import ButtonContainer from '../../sharedcomponents/buttoncontainer/buttonContainer';
import ActivityCheckList from './activityCheckList';
import moment from 'moment';
import { createTheme } from '@mui/material/styles';
const theme = createTheme();
import { makeStyles } from '@mui/styles';
import { ScheduleDataService } from '../../services/ScheduleService';
import Helper from '../../utility/helper';
import { ScheduleUserType } from '../../constants/Constant';

const useStyles = makeStyles(() => ({

    listItemContent: {
        padding: theme.spacing(1, 0),
    },
    paperContent: {
        boxShadow: 'rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px',
        borderRadius: theme.spacing(2),
        padding: theme.spacing(1),
        backgroundColor: '#fff',
        border: '1px solid #efefef',
    },
    accordion: {
        backgroundColor: '#cccccc',

    },
    accordionHeader: {
        textTransform: 'uppercase',
        fontWeight: 600
    }
}));
export default function ActivityListDialog(props)
{
    const classes = useStyles();
    const [activities, setActivities] = useState([])
    const [selected, setSelected] = useState([]);
    const [search, setSearch] = useState('')
    const [dates, setDates] = useState([]);
    const [loading, setLoading] = useState(false);
    const [noloading, setNoloading] = useState(false);

    // useEffect(async () =>
    // {
    //     if (props.activities.length > 0)
    //     { 
    //         setNoloading(true)
    //         const eventInfo = Helper.getStorage('eventInfo');
    //         let result = await ScheduleDataService.getActivityList(
    //             eventInfo.eventID,
    //             0, false
    //         );
    //         let scheduleData = [];
    //         if(result.data && result.data.length > 0){
    //             setNoloading(false)
    //             result.data.map((item) => {
    //                 if (item.userType !== ScheduleUserType[1]) {
    //                     scheduleData.push({ actualData: item });
    //                 }
    //             });
    //         }else{
    //             setNoloading(false)
    //         }
    //         if(scheduleData && scheduleData.length > 0){
    //             let list = scheduleData.filter(x => !x.actualData.participants.map(y => y.userID).includes(props.selectedUser));
    //             console.log("list",list);
    //             setActivities(list);
    //             getDistinctDates(list)
    //         } 
    //     }
    // }, [props.activities, props.selectedUser])
    useEffect(() => {
        const fetchData = async () => {
        if (props.activities.length > 0) {
            setNoloading(true);
            const eventInfo = Helper.getStorage('eventInfo');
    
            await ScheduleDataService.getActivityList(eventInfo.eventID, 0, false)
                .then(result => {
                    let scheduleData = [];
                    if (result.data && result.data.length > 0) {
                        setNoloading(false);
                        result.data.map(item => {
                            if (item.userType !== ScheduleUserType[1]) {
                                scheduleData.push({ actualData: item });
                            }
                        });
                    } else {
                        setNoloading(false);
                    }
    
                    if (scheduleData && scheduleData.length > 0) {
                        let list = scheduleData.filter(
                            x => !x.actualData.participants.map(y => y.userID).includes(props.selectedUser)
                        );
                        console.log("list", list);
                        setActivities(list);
                        getDistinctDates(list);
                    }
                })
                .catch(error => {
                    console.error("Error fetching data:", error);
                    setNoloading(false);
                });
        }
    }
    fetchData();
    }, [props.activities, props.selectedUser]);
    
    
    function getDates(startDate, endDate)
    {
        const dates = []
        let currentDate = startDate
        const addDays = function (days)
        {
            const date = new Date(this.valueOf())
            date.setDate(date.getDate() + days)
            return date
        }
        while (currentDate <= endDate)
        {
            dates.push(moment(currentDate).format('MM/DD/YYYY'))
            currentDate = addDays.call(currentDate, 1)
        }
        return dates
    }
    const getDistinctDates = (data) =>
    {
        let activityDates = []
        data.map((item) =>
        {
            let startDate = item.actualData.startDateTime !== null ? moment(item.actualData.startDateTime).format('MM/DD/YYYY') : null;
            let endDate = null//item.actualData.endDateTime !== null ? moment(item.actualData.endDateTime).format('MM/DD/YYYY') : null;
            let range = [];
            if (startDate !== null && endDate !== null)
            {
                range = getDates(moment(startDate), moment(endDate))
            } else if (startDate !== null && endDate === null)
            {
                range = [startDate];
            } else if (startDate === null && endDate !== null)
            {
                range = [endDate];
            } else
            {
                range = ['TBD']
            }
            //let range = getDates(moment(startDate), moment(endDate))

            activityDates = [...activityDates, ...range]
        })
        let uniqueDates = [... new Set(activityDates)]
        let TBDindex = uniqueDates.indexOf('TBD');
        if (TBDindex > -1)
        {
            uniqueDates.splice(TBDindex, 1)
            uniqueDates = uniqueDates.sort((a, b) => moment(a) - moment(b));
            uniqueDates.unshift('TBD');
        } else
        {
            uniqueDates = uniqueDates.sort((a, b) => moment(a) - moment(b));
        }
        setDates(uniqueDates);
    }
    const checkSelectedActivities = (selectedActivity) =>
    {
        const newSelected = [...selected];
        const currentIndex = newSelected.indexOf(selectedActivity);
        if (currentIndex === -1)
        {
            newSelected.push(selectedActivity);
        } else
        {
            newSelected.splice(currentIndex, 1);
        }
        setSelected(newSelected);
        //setSelected(selectedActivity);
    }
    const handleOnSearchChange = (val) =>
    {

        let value = val.replace(/^\s+/g, '');
        setSearch(value);
        let newActivities = props.activities.filter(x => !x.actualData.participants.map(y => y.userID).includes(props.selectedUser));
        if (value.length > 0)
        {
            // newActivities = newActivities.filter(x => x.actualData.activityName.toLowerCase().indexOf(value.toLowerCase()) > -1)
            let modifyList = [];
            newActivities.forEach((item) =>
            {
                //let data = item;
                item.row.forEach((field, j) =>
                {
                    //let keys = Object.keys(field);
                    //keys.forEach((key) => {
                    if (
                        typeof item.row[j][item.row[j]['key']] === 'string' &&
                        item.row[j][item.row[j]['key']].toLowerCase().indexOf(value.toLowerCase()) > -1
                    )
                    {
                        if (modifyList.indexOf(item) == -1)
                            modifyList.push(item);
                    }
                    //});
                })

            });
            setActivities(modifyList)
            getDistinctDates(modifyList)
        } else
        {
            setActivities([...newActivities])
            getDistinctDates(newActivities);
        }


    }
    const handleClick = () =>
    {

        props.assignActivitiesToParticipant(selected)
        if (selected.length > 0)
            setLoading(true);
    }
    const renderDialogContent = () => (
        <>
            <TextField
                sx={{ marginBottom: '8px' }}
                size="small"
                fullWidth={true}
                placeholder="Search Activity"
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon />
                        </InputAdornment>
                    ),
                }}
                value={search}
                onChange={(event) => handleOnSearchChange(event.target.value)}
            />

            <Box component='div' sx={{ height: '300px', overflowY: 'auto' }}>
            {noloading ? (
                <Box
                    sx={{
                       paddingBottom: '20%'
                    }}
                    className={classes.loader}>
                    <CircularProgress />
                </Box>
            ) : dates.length > 0 ? dates.map((date, index) =>
                {
                    let list = [...activities];
                    let data = list.filter(x =>
                    {
                        if (x.actualData.startDateTime !== null)
                        { //&& x.actualData.endDateTime !== null
                            if (moment(date).format('MM/DD/YYY') == moment(x.actualData.startDateTime).format('MM/DD/YYY'))//&& moment(date).format('MM/DD/YYY') <= moment(x.actualData.endDateTime).format('MM/DD/YYY')
                                return x;
                        } else if (date === 'TBD' && x.actualData.startDateTime === null && x.actualData.endDateTime === null)
                        {
                            return x;
                        }
                    });
                    return <ActivityCheckList key={index}
                        date={date !== 'TBD' ? moment(date).format('dddd, MMMM D, YYYY') : date}
                        data={data}
                        checkUsers={checkSelectedActivities}
                        selected={selected}
                        index={index}
                    />

                }) : (
                    <ListItem className={classes.listItemContent}>
                        <Card
                            classes={{ root: classes.paperContent }}
                            sx={{ width: '100%' }}>
                            <CardContent
                                sx={{ p: 2 }}
                                className={classes.cardContent}>
                                <Box className={classes.rowContent}>
                                    No data found
                                </Box>
                            </CardContent>
                        </Card>
                    </ListItem>
                )}

            </Box>


        </>
    );
    const renderDialogActions = () => (
        <ButtonContainer
            showLoading={true}
            loading={loading}
            handleClick={handleClick}
            handleCancel={props.handleClose}
            buttonText='Add'
        />
    );
    return (
        <CustomDialog
            title={props.title}
            handleClose={props.handleClose}
            open={props.open}
            fullWidth={true}
            maxWidth={'md'}
            renderContent={renderDialogContent}
            renderActions={renderDialogActions}
        />
    )
}
